/**
 * Formatador simples de tempo relativo em PT-BR.
 *
 * Casa o que o usuario espera ler em notificacoes ("há 2h", "há 3d") sem
 * puxar dayjs/date-fns so pra isso. Para coisas muito antigas devolve a
 * data absoluta.
 */
export function formatRelativeTime(iso: string | Date): string {
  const date = typeof iso === 'string' ? new Date(iso) : iso;
  const now = Date.now();
  const diffMs = now - date.getTime();
  if (Number.isNaN(diffMs)) return '';
  const diffSec = Math.max(1, Math.floor(diffMs / 1000));
  if (diffSec < 60) return 'agora';
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `há ${diffMin}min`;
  const diffHour = Math.floor(diffMin / 60);
  if (diffHour < 24) return `há ${diffHour}h`;
  const diffDay = Math.floor(diffHour / 24);
  if (diffDay < 7) return `há ${diffDay}d`;
  if (diffDay < 30) {
    const weeks = Math.floor(diffDay / 7);
    return `há ${weeks}sem`;
  }
  // Para coisas mais antigas, data absoluta.
  return date.toLocaleDateString('pt-BR');
}
